export { baseColors, colors } from "./colors";
export { baseFontSize, fontSizeMap, fontSize } from "./fontSize";
export { fontFamily } from "./fontFamily";
export { fontWeight } from "./fontWeight";
export { lineHeight } from "./lineHeight";
export { spacing } from "./spacing";
export { maxWidth } from "./maxWidth";
export { config } from "./config";

//# sourceMappingURL=index.js.map